import React, { useCallback, useEffect, useRef } from 'react';

const NumberInput = React.forwardRef(function NumberInput(props, ref) {
  const { type = 'number', onWheel, ...rest } = props;
  const inputRef = useRef(null);
  const onWheelRef = useRef(onWheel);
  onWheelRef.current = onWheel;

  const setRefs = useCallback(
    (node) => {
      inputRef.current = node;
      if (typeof ref === 'function') {
        ref(node);
      } else if (ref != null) {
        ref.current = node;
      }
    },
    [ref]
  );

  useEffect(() => {
    const el = inputRef.current;
    if (!el) {
      return undefined;
    }

    const handler = (e) => {
      const cb = onWheelRef.current;
      if (cb) {
        cb(e);
      }
      e.preventDefault();
    };

    el.addEventListener('wheel', handler, { passive: false });
    return () => {
      el.removeEventListener('wheel', handler);
    };
  }, []);

  return <input {...rest} ref={setRefs} type={type} />;
});

export default NumberInput;
